import auth from '@/redux/auth/reducer';
import user from '@/redux/user/reducer';
import quizzes from '@/redux/quizzes/reducer';
import campaign from '@/redux/campaign/reducer';
import challenges from '@/redux/challenges/reducer';
import { type Reducer, combineReducers } from 'redux';

export default combineReducers({ auth, user, quizzes, campaign, challenges }) as Reducer;
